import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseAddComponent } from '../base-add/base-add.component';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PagetagService } from 'src/app/services/pagetag.service';

@Component({
  selector: 'app-pagetag-add',
  templateUrl: './pagetag-add.component.html',
  styleUrls: ['./pagetag-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class PagetagAddComponent extends BaseAddComponent<any> implements OnInit {

  pathUrlList = 'pagetag';

  constructor(
    protected pagetagService: PagetagService,
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router
  ) {
    super(alertService, route, navigator);
    this.service = pagetagService;
    this.item = {};
    this.initFields();
  }

  initFields() {
    this.configFields = [
      {
        type: 'string',
        key: 'title',
        title: 'Titulo',
        caption: ''
      },
      {
        type: 'text',
        key: 'meta',
        title: 'Descripción',
        caption: ''
      },
      {
        type: 'text',
        key: 'tags',
        title: 'Tags',
        caption: ''
      }
    ];
  }
}
